export default __webpack_public_path__ + "static/calendar-2-524fa0a09d6d854e761e1f425a2f8e36.svg";